export const Earncredits = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 82 82" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="41" cy="41" r="34" stroke="currentColor" strokeWidth="5.5" />
    <path
      d="M41 23C41 23 42.875 30.875 47 35C51.125 39.125 59 41 59 41C59 41 51.4531 42.5469 47 47C42.5469 51.4531 41 59 41 59C41 59 38.8906 50.8906 35 47C31.1094 43.1094 23 41 23 41C23 41 30.875 39.125 35 35C39.125 30.875 41 23 41 23Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="5.5"
    />
  </svg>
);
